import { createContext, useContext, useEffect, useState } from "react";
import api, { money } from "@/lib/api";

const CURRENCIES = ["GBP", "EUR", "USD"];
const Ctx = createContext(null);

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(() => {
    const c = localStorage.getItem("eg_currency");
    return CURRENCIES.includes(c) ? c : "GBP";
  });
  const [rates, setRates] = useState({ GBP: 1 });

  useEffect(() => {
    api.get("/rates").then((r) => setRates(r.data.rates)).catch(() => {});
  }, []);

  const setCurrency = (c) => {
    if (!CURRENCIES.includes(c)) return;
    setCurrencyState(c);
    localStorage.setItem("eg_currency", c);
  };

  const rate = rates[currency] || 1;
  const fmt = (gbpAmount) => money((gbpAmount || 0) * rate, currency);

  return <Ctx.Provider value={{ currency, setCurrency, currencies: CURRENCIES, rate, fmt }}>{children}</Ctx.Provider>;
}

export const useCurrency = () => useContext(Ctx);
